export type NavigationItems = {
  title: string;
  icon: string;
  url: string;
  children?: Array<ChildNavigationItem>;
  isBlank?: boolean;
  isInternal?: boolean;
};

type ChildNavigationItem = {
  title: string;
  url: string;
};

export enum NavigateRoutes {
  OPTIONS = 'options',
  INCIDENT = 'incident',
  PARKING_INCIDENT = 'parking-incident',
  TOWING_INCIDENT = 'towing-incident',
  LOCATION = 'location',
  TOWING_LOCATION = 'towing-location',
  E_TICKET = 'e-ticket',
  TOWING_E_TICKET = 'towing-e-ticket',
  MESSAGES_DOCUMENTS = 'messages-documents',
  NO_CONTEST = 'no-contest',
  PAYMENT = 'payment',
  OTHER_INFO = 'other-information',
  FAQ = 'faq',
  PAY_LATER = 'pay-later',
  EXTERNAL_PAYMENT = 'external-payment',
}
